import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import moment from 'moment';
import {InputField, CheckboxField, DropdownField} from '../../../../../common/components/form';
import {required, rangeValue} from '../../../../../common/components/form/common/fieldValidations';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {originModificationDate} from '../../../../../common/constants/datesFormat';
import {resources, scopes} from '../../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../../common/permissions/validations';

const MAX_PICKING_TIME_MINUTES = 60;

const getPickingTimeOptions = () => {
  return Array.from(new Array(MAX_PICKING_TIME_MINUTES), (val, index) => index + 1).map((item) => {
    return {'value': item, 'text': item};
  });
};

const rangeValueBetween1and30 = rangeValue(1, 30);
const rangeValueBetween1and1000 = rangeValue(1, 1000);

class ZoneData extends Component {
  renderStatusField() {
    const {code} = this.props;

    if (!hasAccessPermission(this.props.permissions, resources.PickingZones, scopes.Disabled)) {
      return null;
    }

    return (
      <div className='page-row'>
        <div className='field-label'>
          <label>Estado</label>
        </div>
        <div className='field-component'>
          <Field
            type='toggle'
            name='status'
            component={CheckboxField}
            disabled={!code ||
              !hasAccessPermission(this.props.permissions, resources.PickingZones, scopes.Edit)}
          />
        </div>
      </div>
    );
  }

  renderModificationDateField() {
    const {code, modificationDate} = this.props;

    if (!code) {
      return null;
    }

    return (
      <div className='page-row'>
        <div className='field-label'>
          <label>Última Modificación</label>
        </div>
        <div className='field-component'>
          <p>{moment(modificationDate).format(originModificationDate)}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='page-content'>
        <div className='page-row'>
          <div className='field-label'>
            <label>Nombre*</label>
          </div>
          <div className='field-component'>
            <Field
              name='name'
              component={InputField}
              type='text'
              maxLength='50'
              required
              validate={required}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={clearErrorMessage}
            />
          </div>
        </div>
        <div className='page-row'>
          <div className='field-label'>
            <label>No. Líneas*</label>
          </div>
          <div className='field-component'>
            <Field
              name='lines'
              component={InputField}
              type='number'
              min='1'
              pattern='^[1-9]\d*$'
              required
              validate={rangeValueBetween1and1000}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={clearErrorMessage}
            />
          </div>
        </div>
        <div className='page-row'>
          <div className='field-label'>
            <label>Tiempo Recolección (minutos)*</label>
          </div>
          <div className='field-component'>
            <Field
              name='pickingTime'
              component={DropdownField}
              options={getPickingTimeOptions()}
              required
            />
          </div>
        </div>
        <div className='page-row'>
          <div className='field-label'>
            <label>Recurso (personal)*</label>
          </div>
          <div className='field-component'>
            <Field
              name='people'
              component={InputField}
              type='number'
              min='1'
              pattern='^[1-9]\d*$'
              required
              validate={rangeValueBetween1and30}
              onInvalid={(event) =>
                setErrorMessage('Por favor, llene este campo', event)
              }
              onInput={clearErrorMessage}
            />
          </div>
        </div>
        {this.renderStatusField()}
        {this.renderModificationDateField()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'modificationDate': state.zones.modificationDate,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

export default connect(mapStateToProps)(ZoneData);
